var _path, _path2, _path3, _polygon, _path4, _polygon2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg82(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1,39.89l6.44-19.93c0,0,0.89-3.33,5.04-3.78h22.89c0,0,4,0.22,5.04,3.56L47,40.19c0,0,0.74,1.78-1.11,1.78 l-44.3-0.37C1.59,41.59,0.04,41.37,1,39.89z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.81,39.52h40.44l-5.7-18.07c0,0-0.81-2.81-4.44-2.89H12.48c0,0-2.74,0.3-3.19,3.26L3.81,39.52z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.22,12.41l6.22-6.07c0,0,0.52-0.67,1.41,0l5.78,6.07c0,0,0.74,1.33-0.81,1.78H18.04 C18.04,14.19,16.56,14.11,17.22,12.41z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    points: "21,11.67 24.04,9 26.7,11.67 "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.15,22.58l6.22,6.16c0,0,0.52,0.68,1.41,0l5.78-6.16c0,0,0.74-1.35-0.81-1.8H17.96 C17.96,20.78,16.48,20.85,17.15,22.58z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    points: "20.92,23.33 23.96,26.03 26.63,23.33 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg82);
export default __webpack_public_path__ + "static/media/82.d978c888b47082981278a9f67028e94e.svg";
export { ForwardRef as ReactComponent };